import "./GettingStarted.scss";
import DiagArrow from "../../assets/icons/diag-arrow.svg";

const GettingStarted = ({}) => {
  const subtitle =
    "OC Achievements can transform education, from streamlining admissions and facilitating credit transfers to offering skill certifications and incentivizing learning. Explore how verified creIf you wish to integrate Open Campus Achievements, check our our documentation for more information. If you have any questions, you can also reach out to us at <opencampus email>dentials empower learners, educators, and institutions across the Web3 ecosystem.";

  return (
    <div className="gts-paper-root">
      <div className="container">
        <span className="gts-title">Getting started</span>
        <span className="gts-subtitle mt-20">{subtitle}</span>
        <div className="gts-card-grid">
          <div className="gts-card-root gts-card-blue flex flex-col justify-between">
            <div className="flex flex-col">
              <span className="gts-card-title">Developer Documentation</span>
              <span className="gts-card-subtitle">
                Access comprehensive guides, API setups, code examples, and
                detailed specifications to help you implement achievement
                minting, verification protocols, and more on the EDU Chain
                platform.
              </span>
            </div>
            <a
              className="btn-blue gts-card-btn"
              href="https://devdocs.educhain.xyz/start-building/open-campus-achievements/introduction"
            >
              Dev Docs
              <img src={DiagArrow} alt="diag" className="ml-10" />
            </a>
          </div>
          <div className="gts-card-root gts-card-gray flex flex-col justify-between">
            <div className="flex flex-col">
              <span className="gts-card-title">Reach out</span>
              <span className="gts-card-subtitle">
                Whether you have questions about OC Achievements or need
                technical support, we're here to assist you with all inquiries
                and integration needs.
              </span>
            </div>
            <a
              className="btn-blue gts-card-btn"
              href="mailto:builders@opencampus.xyz"
            >
              Contact Us
              <img src={DiagArrow} alt="diag" className="ml-10" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GettingStarted;
